(() => {
  const labels = document.currentScript.dataset;
  const german = document.documentElement.lang.toLowerCase().startsWith('de');
  const translations = new Map([
    ['Add to cart', labels.addToCart],
    ['Zum Warenkorb hinzufügen', labels.addToCart],
    ['Shop Stricknadeln', labels.shopNeedles],
    ['Browse Garnsets', labels.browseSets],
    ['Einkaufen mit KI', labels.launcher],
    ['Mit KI einkaufen', labels.launcher]
  ]);
  const css = `
    #root {
      --accent: #00965e !important;
      --accent-dark: #00965e !important;
      font-family: var(--gruendl-chat-font, system-ui, sans-serif) !important;
    }
    #root button, #root input, #root textarea { font-family: inherit !important; }
    #root button[class~="bg-background-1-contrast"] {
      background: #008653 !important;
      border-color: #008653 !important;
      color: #fff !important;
      border-radius: 999px !important;
      box-shadow: none !important;
      min-height: 44px;
      max-height: none !important;
      padding: 11px 18px !important;
      font-size: 16px !important;
      line-height: 1.4 !important;
      font-weight: 600 !important;
    }
    #root button[class~="bg-background-1-contrast"]:hover:not(:disabled) {
      background: #007547 !important;
      border-color: #007547 !important;
    }
    #root button[data-component-type="SUGGESTION_CHIP"] {
      background: #f3f9f5 !important;
      border: 1px solid #c8e3d5 !important;
      color: #006e45 !important;
      border-radius: 999px !important;
      box-shadow: none !important;
      min-height: 44px;
      height: auto !important;
      padding: 10px 18px !important;
      font-size: 15px !important;
      line-height: 1.4 !important;
      font-weight: 500 !important;
      white-space: normal;
      max-width: 100%;
    }
    #root button[data-component-type="SUGGESTION_CHIP"]:hover:not(:disabled) {
      background: #e4f2e9 !important;
      border-color: #00965e !important;
    }
    #root button:focus-visible {
      outline: 2px solid #007547 !important;
      outline-offset: 3px !important;
    }
    #root button:disabled { opacity: .5; cursor: not-allowed; }
  `;
  let attempts = 0;
  const bind = () => {
    const host = document.getElementById('ads-agent-host');
    const root = host?.shadowRoot;
    if (!root) {
      if (++attempts < 120) window.setTimeout(bind, 250);
      return;
    }
    host.style.setProperty('--gruendl-chat-font', getComputedStyle(document.body).fontFamily);
    if (labels.avatar) host.style.setProperty('--gruendl-chat-avatar', `url(${JSON.stringify(labels.avatar)})`);
    const style = document.createElement('style');
    style.id = 'gruendl-clarity-brand';
    style.textContent = css + (labels.avatar ? `
      .agent-avatar-bg { background: #fff var(--gruendl-chat-avatar) center / 78% no-repeat !important; }
      .agent-avatar-bg .agent-avatar-sparkle { visibility: hidden; }
    ` : '');
    root.append(style);
    if (!german) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateLabels);
    });
    const updateLabels = () => {
      scheduled = false;
      observer.disconnect();
      root.querySelectorAll('button, [role="button"][aria-label*="Einkaufshilfe"]').forEach(button => {
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const text = node.nodeValue.trim();
          const replacement = translations.get(text);
          if (replacement && replacement !== text) node.nodeValue = node.nodeValue.replace(text, replacement);
        }
        const aria = button.getAttribute('aria-label');
        if (translations.has(aria)) button.setAttribute('aria-label', translations.get(aria));
        if (aria?.includes('Einkaufshilfe')) {
          button.setAttribute('aria-label', `${labels.launcher} Einkaufshilfe`);
          const title = button.querySelector('[class~="text-base-body"]');
          if (title && title.textContent !== labels.launcher) title.textContent = labels.launcher;
        }
      });
      observer.observe(root, { childList: true, characterData: true, subtree: true });
    };
    updateLabels();
  };
  bind();
})();
